// ============================================
// gsap scrollTrigger
// ============================================
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


// ============================================
// スクロールトリガーJS
// ============================================
function animPop() {
  gsap.utils.toArray('.js-pop').forEach((target) => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        start: () => 'top 75%',
        toggleClass: {
          targets: target,
          className: 'is-active',
        },
        once: true,
				// markers: true,
      },
    });
  });
  gsap.utils.toArray('.js-fadeUp').forEach((target) => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        start: () => 'top 75%',
        toggleClass: {
          targets: target,
          className: 'is-active',
        },
        once: true,
      },
    });
  });
  gsap.utils.toArray('.js-animImg').forEach((target) => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        start: () => 'top 50%',
        toggleClass: {
          targets: target,
          className: 'is-active',
        },
        once: true,
      },
    });
  });
}

// ============================================
// 追従
// ============================================

function stickySide() {
	const stickyWrap = document.querySelectorAll('.js-sticky-navWrap');
	const mediaQuery = window.matchMedia('(min-width: 1024px)')

	if (stickyWrap && mediaQuery.matches) {
		const nav = document.querySelector('.js-sticky-nav');

		if (nav) {
			const navItems = nav.querySelectorAll('a');
			const areas = document.querySelectorAll('.js-sticky-target');

			const accordionTriggers = document.querySelectorAll('summary');
			// const accordionCloses = document.querySelectorAll('.js-accordion__close');

			document.querySelectorAll('.js-sticky-nav').forEach(nav => {
				const innerDiv = document.createElement('div');
				innerDiv.classList.add('js-sticky-nav__inner');
				while (nav.firstChild) {
					innerDiv.appendChild(nav.firstChild);
				}
				nav.appendChild(innerDiv);
			});
			stickyWrap.forEach(element => {
				const side = element.querySelector('.js-sticky-nav__inner');
				let elementH = element.clientHeight;
				const sideH = side.clientHeight;

				const sticky = function () {
					ScrollTrigger.getAll().forEach(st => st.kill())
					const tl = gsap.timeline({
						scrollTrigger: {
						// markers: true,
						trigger: side,
						endTrigger: element,
						start: 'top 145px',
						end: `+=${elementH - sideH}`,
						pin: true,
						pinSpacing: false,
					}});
					tl.scrollTrigger.refresh();
				}
				sticky();

				//アクティブ表記
				areas.forEach(area => {
					const activeAct = function () {
						const tl02 = gsap.timeline({
							scrollTrigger: {
							//markers: true,
							trigger: area,
							start: 'top 30%',
							end: `+=${area.clientHeight} 50%`,
							onEnter: () => activateNavItem(area),
							onEnterBack: () => activateNavItem(area),
						}});
						tl02.scrollTrigger.refresh();
					}
					activeAct();
					if (accordionTriggers) {
						accordionTriggers.forEach(trigger => {
							trigger.addEventListener('click', () => {
								setTimeout(() => {
									activeAct();
								}, 200);
							});
						});
					}
				});
				function activateNavItem(area) {
					const currentId = area.getAttribute('id');
					navItems.forEach(el => {
						el.classList.toggle('is-active', el.getAttribute('href') === `#${currentId}`);
					});
				}
			});
		}

	}
}


// ============================================
// export
// ============================================
export { animPop, stickySide };